module.exports = __webpack_public_path__ + "img/ml_image.6311d51f.png";